import {Page} from "../types/page";
import Product, {ProductId} from "../types/product";
import {ApplicationLayout} from "../Layouts";
import {useContext, useEffect, useState} from "react";
import SessionContext, {SessionContextProvider, SessionHelper} from "../services/session/session";
import SummaryPage from "../components/Pages/SummaryPage";
import {JwtApiClient} from "../services/api/api";
import DependentCoverageOptionsPage from "../components/Pages/DependentCoverageOptionsPage";
import PaymentPage from "../components/Pages/PaymentPage";
import ConfirmationPage, {ConfApplicationDownload} from "../components/Pages/ConfirmationPage";
import ProductsStub from "../stub/Products";
import OptInsPage from "../components/Pages/OptInsPage";
import DeclarationsAndSignaturesPage from "../components/Pages/DeclarationsAndSignaturesPage";
import BeneficiariesPage from "../components/Pages/BeneficiariesPage";
import Select from "../components/Forms/Inputs/Select";
import Listeners from "../helpers/listeners";
import FormWithValidation from "../components/Forms/FormWithValidation";
import {HtmlFormValidator} from "../helpers/validator";
import {Button, Col, Container, Row} from "react-bootstrap";
import DemographicsPage from "../components/Pages/Demographics/DemographicsPage";
import LtdDisabilityMemberCoverageOptions from "../components/Pages/LtdDisabilityMemberCoverageOptions";
import UnderwritingPage from "../components/Pages/UnderwritingPage";
import AuthorizationsPage from "../components/Pages/AuthorizationsPage";
import Prescription from "../components/Pages/Prescription";
import {UnderwritingHelper} from "../helpers/underwriting";
import SpouseCoverageOptionsPage from "../components/Pages/SpouseCoverageOptionsPage";
import ScreenCard from "../components/Cards/ScreenCard";
import { BeneficiaryRelationship, GenderOptions } from "../enumerations";
import YesNoSwitch, { YesNoOptions, YesNoToggle } from "../components/Forms/Inputs/YesNoSwitch";


type TestPageProps = {};
const TestPage = (props: TestPageProps) => {
    const [yesNoValue, setYesNoValue] = useState(YesNoOptions.NotSelected);
    const v = new HtmlFormValidator();
return (
    <FormWithValidation
        controlId="test-form"
        validator={v}
        onSubmit={(e) => {
            e.preventDefault();
            // <AuthorizationsPage {...pageProps} />
        }}
    >
        <YesNoToggle
            controlId="test-yesno"
            name="testYesNo"
            value={yesNoValue}
            required={true}
            label="Do you agree?"
            onYesSelected={() => setYesNoValue(YesNoOptions.Yes)}
            onNoSelected={() => setYesNoValue(YesNoOptions.No)}
            invalidMessage="Please select Yes or No."
        />
        <br />
    </FormWithValidation>
);
}
export default TestPage;
